"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'yuqiTable1',
  props: {
    tableData: {
      type: Object,
      required: true
    },
    tableColor: {
      type: String,
      default: '#fef6e9'
    }
  }
};